import { createContext } from "react";

const OrderContext = createContext({});

export default OrderContext;
